import { render } from "./BeerImage.vue?vue&type=template&id=8f8e24d4&scoped=true"
import script from "./BeerImage.vue?vue&type=script&lang=js"
export * from "./BeerImage.vue?vue&type=script&lang=js"

import "./BeerImage.vue?vue&type=style&index=0&id=8f8e24d4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f8e24d4"]])

export default __exports__